angular.module("componentes").directive("menu", function () {
	"use strict";

	return {
		scope: true,
		controller: "menuCtrl",
		controllerAs: "ctrl",
		templateUrl: "componentes/angular-material/custom/sideNav/menu_template.html",
		bindToController: {}
	};
});

Cmp.constructors.DefaultMenu = function DefaultMenu(
	labels,
	userAccessService,
	stockControlAccess,
	internalTransferTypePreference,
	featureAccessService
) {
	"use strict";

	const hasResiduesManagementModule = featureAccessService.hasResiduesManagementModule();
	const hasSupplierViewModule = featureAccessService.hasSupplierViewModule();
	const hasPGRSModule = featureAccessService.hasPGRSModule();
	const hasExecutiveReportsFeature = featureAccessService.hasExecutiveReportsFeature();
	const hasDnitIntegrationFeature = featureAccessService.hasDnitIntegrationFeature();
	const hasIbamaRappIntegrationFeature = featureAccessService.hasIbamaRappIntegrationFeature();

	const masterViewClientDataPermission = userAccessService.hasAccess(Vgr.systemPermissions.MasterViewClientData);

	var viewDisposalPermission = userAccessService.hasAccess(Vgr.systemPermissions.ViewDisposal);

	var viewCollectionRequest =
		userAccessService.hasAccess(
			Vgr.systemPermissions.ViewDisposal,
			null,
			Vgr.constants.featureToggles.release.collectionRequestDisposal
		) ||
		userAccessService.hasAccess(
			Vgr.systemPermissions.EquipmentAllocationView,
			null,
			Vgr.constants.featureToggles.release.collectionRequestDisposal
		) ||
		userAccessService.hasAccess(
			Vgr.systemPermissions.ViewInternalTransfer,
			null,
			Vgr.constants.featureToggles.release.collectionRequestInternalTransfer
		);
	var viewStorageViewGenerated = userAccessService.hasAccess(Vgr.systemPermissions.ViewResiduesGenerated);
	var viewStorageViewStored = userAccessService.hasAccess(Vgr.systemPermissions.ViewResiduesStored);
	var viewStorageViewInternalTransfer = userAccessService.hasAccess(Vgr.systemPermissions.ViewInternalTransfer);
	var viewStorageAnyView = canAccessStorageScreen(
		internalTransferTypePreference,
		viewStorageViewGenerated,
		viewStorageViewStored,
		viewStorageViewInternalTransfer
	);

	var viewGatheringPermission = viewStorageAnyView;

	var viewMarketPermission = userAccessService.hasAccess(Vgr.systemPermissions.ViewMarket);
	var destinatorModuleAccess = userAccessService.getAccess(
		Vgr.systemPermissions.DestinatorModuleView,
		Vgr.constants.featureToggles.permission.destinatorModule
	);

	const viewDeclarationsPermission = userAccessService.hasAccess(Vgr.systemPermissions.ViewDeclarations);
	const viewMaturityPermission = userAccessService.hasAccess(
		Vgr.systemPermissions.MaturityView,
		null,
		Vgr.constants.featureToggles.release.maturityModule
	);
	var webHookEventFeatureAccess = userAccessService.hasAccess(Vgr.systemPermissions.WebhookEventView);
	var apiRequestEventViewAccess = userAccessService.hasAccess(Vgr.systemPermissions.ApiRequestEventView);
	var webhookConfigManageAccess = userAccessService.hasAccess(Vgr.systemPermissions.WebhookConfigManage);
	var equipmentAllocationAccess = userAccessService.getAccess(
		Vgr.systemPermissions.EquipmentAllocationView,
		null,
		Vgr.constants.featureToggles.release.collectionRequestDisposal
	);

	var disposalCollectionRequestReportAccess = userAccessService.getAccess(
		Vgr.systemPermissions.ViewDisposal,
		null,
		Vgr.constants.featureToggles.release.collectionRequestDisposal
	);
	var viewExecutiveReportsPermission = userAccessService.hasAccess(Vgr.systemPermissions.ViewExecutiveReports);
	// PGRS é liberado para o staff master que executa PGRS ou para organizações que contrataram o módulo.
	// Mesma regra aplicada nas rotas pgrs/editPgrs (js/config.js).
	const pgrsAccess =
		userAccessService.hasAccess(Vgr.systemPermissions.MasterExecutePgrs) || hasPGRSModule
			? Vgr.enumerations.userAccess.Enabled
			: Vgr.enumerations.userAccess.Hidden;

	const homeMenu = {
		text: function () {
			return labels.HOME;
		},
		states: ["home"],
		icon: "home",
		level: 0,
		isFree: true
	};

	const requestMenu = {
		text: function () {
			return labels.COLLECTION_REQUEST;
		},
		getFeatureAccess: function () {
			return viewCollectionRequest ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
		},
		states: ["collectionRequestList"],
		level: 0,
		showNewImage: true,
		icon: "event_note"
	};

	const residueManagementMenu = {
		text: function () {
			return labels.RESIDUE_MANAGEMENT;
		},
		icon: "swap_vert",
		level: 0,
		fixed: true,
		disabledHover: true,
		children: getRDMMenuChildren(
			labels,
			viewDisposalPermission,
			destinatorModuleAccess,
			stockControlAccess,
			viewStorageAnyView
		)
	};

	const supplierManagementMenu = {
		text: function () {
			return labels.SUPPLIER_MANAGEMENT;
		},
		icon: "home_work",
		level: 0,
		fixed: true,
		disabledHover: true,
		children: [
			{
				text: function () {
					return labels.CORPORATIVE_CONTROL;
				},
				states: ["supplierList"],
				svgImage: "img/icons/factory.svg",
				level: 1
			},
			{
				text: function () {
					return labels.DOCUMENT_REQUESTS;
				},
				states: ["documentRequestList"],
				icon: "content_paste",
				getFeatureAccess: function () {
					return masterViewClientDataPermission
						? Vgr.enumerations.userAccess.Enabled
						: Vgr.enumerations.userAccess.Hidden;
				},
				level: 1
			}
		]
	};

	const residueMarketMenu = {
		text: function () {
			return labels.SUPPLIER_INDICATIONS;
		},
		states: ["residueMarketNew"],
		level: 0,
		icon: "attach_money",
		getFeatureAccess: function () {
			return viewMarketPermission ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
		}
	};

	const webhooksMenu = {
		text: function () {
			return labels.WEBHOOKS;
		},
		svgImage: "img/icons/deployed_code.svg",
		level: 0,
		children: [
			{
				text: function () {
					return labels.INTEGRATION_WEBHOOK;
				},
				getFeatureAccess: function () {
					return webHookEventFeatureAccess ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
				},
				states: ["webhookEvent"],
				level: 1
			},
			{
				text: function () {
					return labels.INTEGRATIONS_HISTORY;
				},
				getFeatureAccess: function () {
					return apiRequestEventViewAccess ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
				},
				states: ["apiRequestEvent"],
				level: 1
			},
			{
				text: function () {
					return labels.WEBHOOK_CONFIG;
				},
				getFeatureAccess: function () {
					return webhookConfigManageAccess ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
				},
				states: ["webhookConfig"],
				level: 1
			}
		]
	};

	const emailRequestMenu = {
		text: function () {
			return labels.EMAIL_MANAGEMENT;
		},
		getFeatureAccess: function () {
			return masterViewClientDataPermission ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
		},
		states: ["emailRequestList"],
		level: 0,
		icon: "mail"
	};

	const statementsMenu = getStatementsMenu(
		labels,
		hasResiduesManagementModule,
		viewDisposalPermission,
		viewGatheringPermission,
		hasIbamaRappIntegrationFeature,
		hasDnitIntegrationFeature,
		viewDeclarationsPermission,
		pgrsAccess
	);

	const biMenu = getBiMenu(
		labels,
		viewGatheringPermission,
		viewDisposalPermission,
		hasExecutiveReportsFeature && viewExecutiveReportsPermission,
		disposalCollectionRequestReportAccess
	);

	const equipmentAllocationMenu = {
		text: function () {
			return labels.EQUIPMENT_ALLOCATION;
		},
		level: 0,
		states: ["equipmentAllocationList", "equipmentAllocationDetail"],
		getFeatureAccess: function () {
			return equipmentAllocationAccess;
		},
		icon: "inventory_2"
	};

	const maturityMenu = {
		text: function () {
			return labels.MATURITY;
		},
		clickMeasureKey: Vgr.trackings.maturity.access,
		getFeatureAccess: function () {
			const hasAccess = viewMaturityPermission || masterViewClientDataPermission;

			return hasAccess ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
		},
		states: ["editMaturity"],
		icon: "star",
		level: 0
	};

	const mainBiMenu = {
		text: function () {
			return labels.BI_DASHBOARD;
		},
		icon: "query_stats",
		level: 0,
		states: ["bi"]
	};

	const emissionsBiMenu = {
		text: function () {
			return labels.EMISSIONS_PANEL;
		},
		icon: "co2",
		level: 0,
		states: ["esgEmbedPowerbi"]
	};

	const childrenMenus = [homeMenu];
	if (hasResiduesManagementModule) {
		childrenMenus.push(mainBiMenu);
		childrenMenus.push(emissionsBiMenu);
		childrenMenus.push(requestMenu);
		childrenMenus.push(equipmentAllocationMenu);
		childrenMenus.push(residueManagementMenu);
		childrenMenus.push(supplierManagementMenu);
		childrenMenus.push(biMenu);
		childrenMenus.push(statementsMenu);
		childrenMenus.push(maturityMenu);
		childrenMenus.push(residueMarketMenu);
		childrenMenus.push(webhooksMenu);
		childrenMenus.push(emailRequestMenu);
	}
	if (hasSupplierViewModule) {
		childrenMenus.push(getSupplierViewMenu(labels));
	}
	if (hasPGRSModule && !hasResiduesManagementModule) {
		childrenMenus.push(statementsMenu);
	}
	this.children = childrenMenus;
};

function canAccessStorageScreen(
	internalTransferTypePreference,
	viewStorageViewGenerated,
	viewStorageViewStored,
	viewStorageViewInternalTransfer
) {
	if (internalTransferTypePreference == Vgr.enumerations.internalGathering.internalTransferType.FullTransfer) {
		return viewStorageViewInternalTransfer || viewStorageViewGenerated || viewStorageViewStored;
	} else if (
		internalTransferTypePreference == Vgr.enumerations.internalGathering.internalTransferType.TwoStepTransfer
	) {
		return viewStorageViewGenerated || viewStorageViewStored;
	} else {
		return viewStorageViewStored;
	}
}

function getBiMenu(
	labels,
	viewGatheringPermission,
	viewDisposalPermission,
	viewExecutiveReportsPermission,
	disposalCollectionRequestReportAccess
) {
	var children = [];

	const viewGatherOrDisposalAccess =
		viewGatheringPermission || viewDisposalPermission
			? Vgr.enumerations.userAccess.Enabled
			: Vgr.enumerations.userAccess.Hidden;

	children = [
		{
			text: function () {
				return labels.CUSTOM_REPORTS;
			},
			states: ["customReport"],
			level: 1
		},
		{
			text: function () {
				return labels.KEY_PERFORMANCE_INDICATORS;
			},
			states: ["genericKpiReport"],
			level: 1
		},
		{
			text: function () {
				return labels.RESIDUE_TRACEABILITY_REPORT_TITLE;
			},
			states: ["residueTraceabilityReport"],
			clickMeasureKey: Vgr.trackings.residueTraceability.usingMenu,
			level: 1
		},
		{
			text: function () {
				return labels.DISPOSAL_COLLECTION_REQUEST_REPORT_TITLE;
			},
			states: ["disposalCollectionRequestReport"],
			level: 1,
			getFeatureAccess: function () {
				return disposalCollectionRequestReportAccess;
			}
		},
		{
			text: function () {
				return labels.EXECUTIVE_REPORT_SUPPLIERS;
			},
			states: ["executiveReportSuppliers"],
			level: 1,
			getFeatureAccess: function () {
				return viewExecutiveReportsPermission
					? Vgr.enumerations.userAccess.Enabled
					: Vgr.enumerations.userAccess.Hidden;
			}
		},
		{
			text: function () {
				return labels.RESIDUE_MOVIMENTATION_REPORT_TITLE_MENU;
			},
			level: 1,
			states: ["residueMovimentationReport"],
			getFeatureAccess: function () {
				return viewGatherOrDisposalAccess;
			}
		},
		{
			text: function () {
				return labels.RELATIVE_KEY_PERFORMANCE_INDICATORS;
			},
			states: ["relativeKpis"],
			level: 1
		},
		{
			text: function () {
				return labels.INVENTORY_REPORT;
			},
			states: ["generatingManagementInventoryReport"],
			level: 1,
			getFeatureAccess: function () {
				return viewGatherOrDisposalAccess;
			}
		},
		{
			text: function () {
				return labels.BALANCE_REPORT_TITLE;
			},
			states: ["cadriBalanceReport"],
			level: 1
		}
	];

	return {
		text: function () {
			return labels.REPORTS;
		},
		icon: "insights",
		level: 0,
		children: children
	};
}

function getStatementsMenu(
	labels,
	hasResiduesManagementModule,
	viewDisposalPermission,
	viewGatheringPermission,
	hasIbamaRappIntegrationFeature,
	hasDnitIntegrationFeature,
	viewDeclarationsPermission,
	pgrsAccess
) {
	var ibamaRappIntegrationAccess = Vgr.enumerations.userAccess.Hidden;
	var viewGatherOrDisposalAccess = Vgr.enumerations.userAccess.Hidden;
	var dmrAccess = Vgr.enumerations.userAccess.Hidden;
	var dnitIntegrationAccess = Vgr.enumerations.userAccess.Hidden;
	if (hasResiduesManagementModule) {
		if (viewGatheringPermission || viewDisposalPermission) {
			viewGatherOrDisposalAccess = Vgr.enumerations.userAccess.Enabled;
		}
		if (viewDeclarationsPermission) {
			dmrAccess = Vgr.enumerations.userAccess.Enabled;
		}
		if (viewDisposalPermission && hasDnitIntegrationFeature) {
			dnitIntegrationAccess = Vgr.enumerations.userAccess.Enabled;
		}
		if (hasIbamaRappIntegrationFeature && viewDeclarationsPermission) {
			ibamaRappIntegrationAccess = Vgr.enumerations.userAccess.Enabled;
		}
	}

	var children = [
		{
			text: function () {
				return labels.PGRS;
			},
			states: ["pgrs"],
			level: 1,
			getFeatureAccess: function () {
				return pgrsAccess;
			},
			isFree: true
		},
		{
			text: function () {
				return labels.DMR;
			},
			states: ["dmrReport"],
			level: 1,
			getFeatureAccess: function () {
				return dmrAccess;
			}
		},
		{
			text: function () {
				return labels.RAPP_IBAMA;
			},
			level: 1,
			children: [
				{
					text: function () {
						return labels.STATEMENT;
					},
					states: ["ibamaReport"],
					level: 2,
					getFeatureAccess: function () {
						return viewGatherOrDisposalAccess;
					}
				},
				{
					text: function () {
						return labels.INTEGRATION;
					},
					getFeatureAccess: function () {
						return ibamaRappIntegrationAccess;
					},
					states: ["ibamaRappList"],
					level: 2
				}
			]
		},
		{
			text: function () {
				return labels.DNIT_INTEGRATION;
			},
			states: ["dnitReport"],
			level: 1,
			getFeatureAccess: function () {
				return dnitIntegrationAccess;
			}
		},
		{
			text: function () {
				return labels.CONAMA313_INVENTORY;
			},
			states: ["conamaInvetoryReport"],
			level: 1,
			getFeatureAccess: function () {
				return viewGatherOrDisposalAccess;
			}
		}
	];

	return {
		text: function () {
			return labels.STATEMENTS;
		},
		icon: "summarize",
		level: 0,
		children: children,
		isFree: true
	};
}

function getRDMMenuChildren(
	labels,
	viewDisposalPermission,
	destinatorModuleAccess,
	stockControlAccess,
	viewStorageAnyPermission
) {
	const storageMenuItem = {
		text: function () {
			return labels.STORE;
		},
		states: ["storageList"],
		icon: "arrow_circle_down",
		level: 1,
		getFeatureAccess: function () {
			return viewStorageAnyPermission && stockControlAccess
				? Vgr.enumerations.userAccess.Enabled
				: Vgr.enumerations.userAccess.Hidden;
		}
	};

	const disposalModelsMenuItem = {
		text: function () {
			return labels.DESTINATE;
		},
		clickMeasureKey: Vgr.trackings.disposal.disposalModel.usingMenu,
		states: ["disposalModels"],
		icon: "add_circle_outline",
		level: 1,
		getFeatureAccess: function () {
			return viewDisposalPermission ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
		}
	};

	const mtrFollowupMenuItem = {
		text: function () {
			return labels.FOLLOW_MTR;
		},
		clickMeasureKey: Vgr.trackings.disposal.manifest.followupAccessUsingMenu,
		states: ["mtrFollowUp"],
		icon: "fact_check",
		level: 1,
		getFeatureAccess: function () {
			return viewDisposalPermission ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
		}
	};

	const disposalMenuItem = {
		text: function () {
			return labels.FOLLOWUP_DISPOSAL;
		},
		clickMeasureKey: Vgr.trackings.disposal.followupAccess.usingMenu,
		states: ["disposalFollowup"],
		icon: "view_week",
		level: 1,
		getFeatureAccess: function () {
			return viewDisposalPermission ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
		}
	};

	const disposalHistoryMenuItem = {
		text: function () {
			return labels.EXTERNAL_GATHERING_HISTORY;
		},
		states: ["disposalHistory"],
		icon: "list_alt",
		level: 1,
		getFeatureAccess: function () {
			return viewDisposalPermission ? Vgr.enumerations.userAccess.Enabled : Vgr.enumerations.userAccess.Hidden;
		}
	};

	const receiveAsDestinatorMenuItem = {
		icon: "arrow_circle_down",
		level: 1,
		states: ["destinatorDisposalManifestList"],
		text: function () {
			return labels.RECEIVE_MTR;
		},
		getFeatureAccess: function () {
			return destinatorModuleAccess;
		}
	};

	return [
		storageMenuItem,
		disposalModelsMenuItem,
		disposalHistoryMenuItem,
		mtrFollowupMenuItem,
		disposalMenuItem,
		receiveAsDestinatorMenuItem
	];
}

function getSupplierViewMenu(labels) {
	const children = [
		{
			text: function () {
				return labels.DOCUMENTS;
			},
			level: 1,
			states: ["supplierDashboard"],
			stateParams: {
				tab: 0
			},
			isFree: true
		},
		{
			text: function () {
				return labels.AUDITS_AND_OTHERS;
			},
			level: 1,
			states: ["supplierDashboard"],
			stateParams: {
				tab: 1
			},
			isFree: true
		},
		{
			text: function () {
				return labels.ACTION_PLANS;
			},
			level: 1,
			states: ["supplierDashboard"],
			stateParams: {
				tab: 2
			},
			isFree: true
		},
		{
			text: function () {
				return labels.COLLECTION_REQUEST;
			},
			level: 1,
			states: ["supplierViewCollectionRequestList"],
			isFree: true
		}
	];
	return {
		text: function () {
			return labels.SUPPLIERS;
		},
		icon: "home_work",
		level: 0,
		fixed: true,
		disabledHover: true,
		isFree: true,
		children: children
	};
}
